import * as React from 'react';
import { Header4, InlineText2 } from '@cian/ui-kit';

import { IHouseStats } from '../../../../types/newbuilding/genplan';
import { EscrowLabel, ReliableLabel } from '../../../Labels';
import { SalesStartLabel } from '../../../SalesStartLabel';
import { HouseStats } from '../HouseStats';

import * as styles from './styles.css';

interface IHouseTooltipProps {
  name: string;
  houseId: number;
  houseInfo: string[];
  stats: IHouseStats | null;
  isReliable: boolean;
  isEscrow: boolean;
  isSalesStart?: boolean;
  onLinkClick(houseId: number, rooms?: string): void;
  onReliableLabelClick(event: React.MouseEvent<HTMLElement>): void;
  onEscrowLabelClick(event: React.MouseEvent<HTMLElement>): void;
}

export function HouseTooltipAB({
  name,
  houseId,
  houseInfo,
  stats,
  isReliable,
  isEscrow,
  isSalesStart,
  onLinkClick,
  onReliableLabelClick,
  onEscrowLabelClick,
}: IHouseTooltipProps) {
  return (
    <div className={styles['container']}>
      <Header4>{name}</Header4>
      {isSalesStart && (
        <div className={styles['sales-start']}>
          <SalesStartLabel />
        </div>
      )}
      <div className={styles['house-info']}>
        {houseInfo.map((item, i) => (
          <InlineText2 key={item} color="gray60_100" whiteSpace="nowrap">
            {item}
            {i < houseInfo.length - 1 ? ' • ' : ''}
          </InlineText2>
        ))}
      </div>

      {(isReliable || isEscrow) && (
        <div className={styles['labels']}>
          {isReliable && <ReliableLabel light={true} onClick={onReliableLabelClick} />}
          {isEscrow && <EscrowLabel dark={true} onClick={onEscrowLabelClick} />}
        </div>
      )}

      {stats && <HouseStats {...stats} houseId={houseId} onLinkClick={onLinkClick} />}
      {!stats && (
        <div className={styles['line']}>
          <InlineText2>Нет квартир в продаже</InlineText2>
        </div>
      )}
    </div>
  );
}
